import React from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import Moment from 'react-moment';

const CardItem = props => {
  const { title, summary, published_date, path } = props.data;

  return (
    <>
      <Card className="col-12 col-md-4 m-0 mb-2 p-2">
        <div className="inner">
          <Card.Title className="fw-800 p-4">
            <a href={path} title={title}>
              {title}
            </a>
          </Card.Title>
          <Card.Body className="pl-4">
            <div className="w-100">
              <span className="fw-800">
                <Moment format="Do MMMM YYYY">{published_date}</Moment>
              </span>
            </div>
            <div
              className="content fw-400 mb-2"
              dangerouslySetInnerHTML={{__html: summary}}
            />
          </Card.Body>

          <Card.Footer className="pt-0 pb-0">
            <Row className="p-0 m-0">
              <Col className="p-0 m-0">
                <Button href={path}>Read more</Button>
              </Col>
            </Row>
          </Card.Footer>
        </div>
      </Card>
    </>
  );
};

export default CardItem;
